import { graphql } from '../../graphql/graphql';
import { weblinkFragment } from '../../graphql/fragments/weblinkFragment';
import { propertyPageCtaButtonFragment } from './fragments/propertyPageCtaButtonFragment';
import { propertyPageCtaToggleFragment } from './fragments/propertyPageCtaToggleFragment';
import { propertyPageCtaLinkFragment } from './fragments/propertyPageCtaLinkFragment';

export const headerCtasBySlugQuery = graphql(
  `
    query HeaderCtasBySlug($id: ID!, $slug: Uri!, $isPropertyReportEnabled: Boolean = false) {
      propertyPageBySlugV3(id: $id, slug: $slug) {
        ... on PropertyPage_Page {
          __typename
          ...HeaderCtasBySlugQuery_PropertyPage_Page
        }
      }
    }

    fragment HeaderCtasBySlugQuery_PropertyPage_Page on PropertyPage_Page {
      header {
        ctas @skip(if: $isPropertyReportEnabled) {
          __typename
          items {
            ...PropertyPage_HeaderCtas
          }
        }
        ctasV2 @include(if: $isPropertyReportEnabled) {
          items {
            __typename
            ... on PropertyPage_CtaToggle {
              __typename
              ...PropertyPage_CtaToggle
            }
            ... on PropertyPage_CtaButton {
              __typename
              ...PropertyPage_CtaButton
            }
            ... on PropertyPage_CtaLink {
              __typename
              ...PropertyPage_CtaLink
            }
          }
        }
      }
    }

    fragment PropertyPage_HeaderCtas on PropertyPage_HeaderCtas {
      __typename
      ... on PropertyPage_CtaButton {
        __typename
        ...PropertyPage_CtaButton
      }
      ... on WebLink {
        __typename
        ...WebLink
      }
    }
  `,
  [
    weblinkFragment,
    propertyPageCtaButtonFragment,
    propertyPageCtaToggleFragment,
    propertyPageCtaLinkFragment,
  ],
);
